import React from 'react'
import KvkkPage from './components/KvkkPage'

export default function Kvkk() {
  return <KvkkPage/>
}
